<template>
  <div>
    <div class="botonera-usuaris">
      <b-button size="sm" id="usuaris-btn-nou" variant="primary" @click.prevent="onCrearUsuari({})">
        <b-icon icon="plus" aria-hidden="true"></b-icon> {{$t('btn.nou.usuari')}}
      </b-button>
      <b-button-group size="sm" id="usuaris-btn-cercar">
        <b-button size="sm" v-b-toggle.collapse-filtre  variant="outline-primary">
          <b-icon icon="filter" aria-hidden="true"></b-icon>
        </b-button>
        <b-button size="sm" variant="outline-primary" @click.prevent="listUsuaris()">
          <b-icon icon="search" aria-hidden="true"></b-icon> {{$t('btn.cercar')}}
        </b-button>
      </b-button-group>
    </div>


    <b-collapse id="collapse-filtre" class="mt-2">
      <b-card class="filtre-usuaris">
        <b-row>
          <b-col lg="3" md="8" sm="10">
            <b-input-group size="sm" prepend="Nom usuari: ">
              <b-form-input id="filter-input" type="search" placeholder="Escriviu el nom d'un usuari" v-model="cercaNomUsuari" ref="formInputCerca" style="z-index:1;"> </b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="9" md="10" sm="12" class="filtre-btn-usuaris">
            <b-button size="sm" variant="outline-primary" @click.prevent="onResetFiltreCerca()">
              <b-icon icon="trash" aria-hidden="true"></b-icon> Eliminar filtre
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>

    <template>
      <div>
        <b-table id="usuaris-table" ref="usuarisTable" small :fields="fields" :items="files" responsive="sm" :current-page="currentPageStatic" :per-page="perPageStatic">
          <template v-slot:cell()="data">
            <div class="mb-2">
              <b-card no-body >
                <b-card-header class="header-usuari">
                  <b-row>
                    <b-col lg="9" md="8" sm="6"><b>LListat d'Usuaris</b></b-col>
                  </b-row>
                </b-card-header>

                <div class="accordion" role="tablist">

                  <b-collapse visible :id="`${'collapse-usuaris-'+data.id}`" :accordion="`${'accordion-'+data.id}`" role="tabpanel">
                    <b-list-group flush>
                      <b-list-group-item class="titol-usuari">
                        <b-row no-gutters >
                          <b-col md="1" sm="3">
                            <span class="label-titol-usuari">{{$t('admin.usuaris.llistat.nom')}}</span>
                          </b-col>
                          <b-col md="4" sm="10">
                            <span class="label-titol-usuari">{{$t('admin.usuaris.llistat.rols')}}</span>
                          </b-col>
                          <b-col md="2" sm="6">
                            <span class="label-titol-usuari">{{$t('admin.usuaris.llistat.creacio')}}</span>
                          </b-col>
                          <b-col md="2" sm="6">
                            <span class="label-titol-usuari">{{$t('admin.usuaris.llistat.baixa')}}</span>
                          </b-col>
                          <b-col md="1" sm="3">
                            <span class="label-titol-usuari">{{$t('admin.usuaris.llistat.entitat')}}</span>
                          </b-col>
                          <b-col md="3" sm="12">
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                      <template v-for="(item) in itemsForList">
                        <ItemUsuari v-bind:key='item.idUsuari+mountedTime' v-bind:initialValue="item" v-on:eliminar-usuari="onEliminarUsuari" v-on:editar-usuari="onCrearUsuari" v-on:usuari-baixa="onUsuariBaixa" />
                      </template>
                    </b-list-group>
                  </b-collapse>

                </div>

              </b-card>

            </div>
          </template>
        </b-table>
      </div>
    </template>

    <b-pagination v-model="currentPage" pills align="center" :total-rows="rows" :per-page="perPage" aria-controls="usuaris-table"></b-pagination>

    <ModalEdicioUsuari :id="`${'modal-'+this.accioUsuariModalId+'-usuari'}`" v-bind:usuari="usuari" v-on:usuari-editat="onUsuariEditada"/>

  </div>
</template>

<script>
import usuariAplicacioService from "@/services/UsuariAplicacioService";
import ItemUsuari from "@/components/admin/ItemUsuari";
import ModalEdicioUsuari from "@/components/admin/ModalEdicioUsuari";
export default {
  name: "admin-usuaris",
  components: {
    ItemUsuari,
    ModalEdicioUsuari
  },
  computed:{
    fields(){
      //Els fiquem a computed per les traduccions
      return [
        { key: 'e', label: '',thClass:'th-usuaris-table',tdClass:'td-usuaris-table' }
      ];
    },
    itemsForList() {
      return this.items.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage,
      );
    }
  },
  data() {
    return {
      //id neecessari perquè la taula només tingui una única fila i pugui contenir a dins tot el llistat
      files: [
        { id: 1 },
      ],
      cercaNomUsuari: '',
      usuari: {},
      entitatUsuariActual: {},
      filtre:{},
      rows: 0,
      perPageStatic: 1,
      currentPageStatic: 1,
      perPage: 15,
      currentPage: 1,
      usuaris: [],
      items: [],
      initialValue: {},
      rowSelected: {},
      mountedTime:null,
      accioUsuariModalId:null
    };
  },
  methods: {
    async listUsuaris() {
      try{
        const response = await usuariAplicacioService.listUsuaris(this.filtre);
        console.log(response.data);
        this.usuaris =response.data;
        this.initItems();
      }catch(e){
        console.log(e);
      }
    },
    initItems(){
      this.items = this.usuaris.filter(usuari => usuari.nomUsuari.includes(this.cercaNomUsuari));

      console.log(this.items);
      this.rows = this.items.length;
      this.$root.$emit('bv::refresh::table', 'usuaris-table')
    },
    onCrearUsuari(data) {
      this.accioUsuariModalId= this.usuari.idUsuari ?'editar' : 'crear';
      console.log("this.accioUsuariModalId");
      console.log(this.accioUsuariModalId);
      this.usuari = data;
      this.$nextTick(() => {
        this.$bvModal.show('modal-'+this.accioUsuariModalId+'-usuari')
      })
    },
    onUsuariEditada(data) {
      if(!this.usuari.idUsuari){
        this.items.unshift(data);
      }else{
        let i;
        for(i = 0; i < this.items.length; i++) {
          if(this.items[i].idUsuari === data.idUsuari){
            this.items[i] = data;
          }
        }

      }
      this.listUsuaris();
      this.rows = this.items.length;
      this.$root.$emit('bv::refresh::table', 'usuaris-table')
      this.$refs.usuarisTable.refresh();
    },
    onEliminarUsuari(data) {
      console.log(data.idUsuari);
      let idUsuariEliminar = data.idUsuari;
      console.log(idUsuariEliminar);
      usuariAplicacioService.eliminarUsuari(idUsuariEliminar).then(response => {
        if(response.status == 200){
          this.items = this.items.filter(item => item.idUsuari !== idUsuariEliminar)
          this.rows = this.items.length;
          this.$root.$emit('bv::refresh::table', 'usuaris-table')
          this.$refs.usuarisTable.refresh();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    onUsuariBaixa(data){
      console.log("onUsuariBaixa - data");
      console.log(data);
      let idUsuariBaixa = data.idUsuari;
      usuariAplicacioService.donarBaixaUsuari(idUsuariBaixa).then(response => {
        if (response.status == 200){
          this.listUsuaris();
        }
      }).catch(e => {
        console.error(e.response.data);
        console.error(e.response.data.error);
        console.error(e.message);
        console.log(e);
      })
    },
    onResetFiltreCerca(){
      console.log("Entro a resetFiltre");
      console.log(this.$refs["formInputCerca"].value);

      // this.$refs["formInputCerca"].value = "";

      console.log(this.$refs["formInputCerca"].value);
      this.cercaNomUsuari = '';
      this.initItems();

    }
  },
  mounted() {
    this.mountedTime = new Date().getTime();
  },
  created () {
    this.listUsuaris();
  }
};
</script>

<style>
.botonera-usuaris {
  text-align: right;
  margin-top: 10px;
  margin-bottom: 10px
}
.filtre-btn-usuaris {
  text-align: right;
}
#usuaris-btn-cercar{
  margin-right: 5px;
}
#usuaris-btn-nou{
  margin-right: 5px;
}
#usuaris-table{
  text-align: left;
  color: #858796;
  border: 0 solid #e3e6f0;
}

.th-usuaris-table{
  vertical-align: middle !important;
  padding: .45rem !important;
}
.td-usuaris-table{
  vertical-align: middle !important;
  padding: 0 !important;
}
.td-progress-bar{
  min-width: 80px;
}

.header-usuari{
  padding: 0.2rem 1.25rem;
  background-color:rgba(0, 0, 0, 0.128);
}
.titol-usuari{
  padding-top: 2px;
  padding-bottom: 2px;
  background-color:rgba(0, 0, 0, 0.068);
}
.label-titol-usuari{
  font-weight: 500;
  font-size: 14px;
}

</style>